import { render, staticRenderFns } from "./PromotionProduct.vue?vue&type=template&id=6d46da80&scoped=true&"
import script from "./PromotionProduct.vue?vue&type=script&lang=js&"
export * from "./PromotionProduct.vue?vue&type=script&lang=js&"
import style0 from "./PromotionProduct.vue?vue&type=style&index=0&id=6d46da80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d46da80",
  null
  
)

export default component.exports